/*
 * header-fade-after-poster.js
 *
 * Adds body.hero-loaded as soon as the page's hero element
 * (LCP image / video poster) finishes loading. CSS then fades the
 * header in over 3s via animation.
 *
 * Multiple safety nets so the class always lands, no matter what:
 *  - Direct img.complete check for cached images
 *  - load + error handlers on the hero element
 *  - window.load fallback (every resource done)
 *  - 3 s wall-clock timeout regardless
 *  - try/catch around DOM queries
 */
(function () {
  var fired = false;

  function flagReady() {
    if (fired) return;
    fired = true;
    if (document.body) {
      document.body.classList.add('hero-loaded');
      document.body.classList.add('poster-loaded');
    }
  }

  function watchImage(img) {
    if (!img) return false;
    if (img.complete && img.naturalWidth > 0) {
      flagReady();
      return true;
    }
    img.addEventListener('load', flagReady, { once: true });
    img.addEventListener('error', flagReady, { once: true });
    return true;
  }

  function init() {
    try {
      // 1. Hero image with fetchpriority="high" (image-banner LCP)
      var lcpImg = document.querySelector('img[fetchpriority="high"]');
      if (watchImage(lcpImg)) return;

      // 2. Slideshow video poster
      var video = document.querySelector(
        '.item-video video[poster], .slide-video video[poster], .slideshow video[poster]'
      );
      var posterSrc = video && video.getAttribute('poster');
      if (posterSrc) {
        var pImg = new Image();
        pImg.onload = flagReady;
        pImg.onerror = flagReady;
        pImg.src = posterSrc;
        if (pImg.complete) flagReady();
        return;
      }

      // 3. First eager-loaded img above the fold
      var firstImg = document.querySelector('img[loading="eager"]');
      if (watchImage(firstImg)) return;

      // No hero found — fade in immediately.
      flagReady();
    } catch (e) {
      // Anything went wrong — make sure header still shows.
      flagReady();
    }
  }

  // Run after DOMContentLoaded so the hero element exists.
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Safety net 1: window.load fires when every resource is done.
  window.addEventListener('load', flagReady);

  // Safety net 2: wall-clock timeout. Header is visible within 3 s
  // no matter what — slow connections, broken JS, missing hero, etc.
  setTimeout(flagReady, 3000);
})();
